import Vue from "vue";

Vue.filter("priceFilter", function(value) {
  if (value === "已包含") {
    return value;
  }
  let price = value + "";
  let result = "";
  while (price.length > 3) {
    result = "," + price.slice(-3) + result;
    price = price.slice(0, price.length - 3);
  }
  return "￥" + price + result;
});
